import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=8c8b8354&scoped=true"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=8c8b8354&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8b8354",
  null
  
)

export default component.exports